<template>
  <b-nav-item @click="skin = isDark ? 'light' : 'dark'">
    <feather-icon 
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
      :style="{ color: appColor }"
    />
  </b-nav-item>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')
    const { appColor } = $themeConfig.app

    return { skin, isDark,appColor }
  },
}
</script>
